// extracted by mini-css-extract-plugin
export default {"footerContainer":"SwqulHtaXQAXuR_RloqY"};